<template>
    <b-container class="checkout_wrapper">
        <b-row>
            <b-col>
                <h2>Thanks for your Order!</h2>
                <p>Your ready-to-load prompts will be delivered the day after <strong>{{talentName}}</strong> records. <span v-if="recordSchedule">Make sure you've referenced our recording calendar for complete details.</span></p>

                <table v-if="recordSchedule" class="schedule table table-bordered table-fixed text-center">
                    <thead>
                        <th>Monday</th>
                        <th>Tuesday</th>
                        <th>Wednesday</th>
                        <th>Thursday</th>
                        <th>Friday</th>
                    </thead>
                    <tbody>
                        <tr>
                            <td v-for="day in weekdays" v-bind:key="day">
                                <font-awesome-icon v-if="typeof schedule[day] !== 'undefined'" :icon="schedule[day]" size="4x" />
                                <span v-if="schedule[day] == 'file-alt'">Submit Project By</span>
                                <span v-if="schedule[day] == 'microphone'">{{talentName}} Records</span>
                                <span v-if="schedule[day] == 'file-audio'">Audio Delivered</span>
                            </td>
                        </tr>
                    </tbody>
                </table>


                <p><strong>Important: 24/7 Pronunciation Mailbox</strong></p>

                <p>If your script contains unique names, cities, streets, acronyms or industry terms, please call the pronunciation mailbox to guarantee the correct pronunciation of your script.</p>

                <p>The process is easy:</p>

                <p>Call (770).752.4500, press option 4 and follow the simple instructions (please have your order number on hand; listed above).
                Speak your unique pronunciations slowly and clearly.</p>

                <p>If you have any questions, please contact <a href="mailto:store@gmvoices.com">store@gmvoices.com</a>.</p>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="6">
                <b-card>
                    <table class="table mb-0 billing" v-if="project">
                        <tbody>
                            <tr class="first">
                                <th>First Name</th>
                                <td>{{billing.first_name}}</td>
                            </tr>
                            <tr>
                                <th>Last Name</th>
                                <td>{{billing.last_name}}</td>
                            </tr>
                            <tr>
                                <th>Street 1</th>
                                <td>{{billing.street_1}}</td>
                            </tr>
                            <tr>
                                <th>Street 2</th>
                                <td>{{billing.street_2}}</td>
                            </tr>
                            <tr>
                                <th>City</th>
                                <td>{{billing.city}}</td>
                            </tr>
                            <tr>
                                <th>State</th>
                                <td>{{billing.state}}</td>
                            </tr>
                            <tr>
                                <th>Zip Code</th>
                                <td>{{billing.postal_code}}</td>
                            </tr>
                            <tr>
                                <th>Country</th>
                                <td>{{billing.country}}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>
            </b-col>
            <b-col md="6">
                <b-card>
                    <table class="table mb-0 order" v-if="project">
                        <tbody>
                            <tr class="first">
                                <th>Order Number</th>
                                <td>{{ordernumber}}</td>
                            </tr>
                            <tr>
                                <th>Project Name</th>
                                <td>{{project.name}}</td>
                            </tr>
                            <tr>
                                <th>Talent</th>
                                <td>{{talentName}}</td>
                            </tr>
                            <tr>
                                <th>Word Count</th>
                                <td>{{project.word_count}}</td>
                            </tr>
                            <tr>
                                <th>Recording Fee</th>
                                <td>${{project.record_fee}}</td>
                            </tr>
                            <tr>
                                <th>Extra Words Fee</th>
                                <td>${{extra_words_fee}}</td>
                            </tr>
                            <tr>
                                <th>Coupon</th>
                                <td>
                                    <span v-if="coupon.coupon_code">{{coupon.coupon_code}} (- ${{coupon_amount}})</span>
                                    <span v-else>N/A</span>
                                </td>
                            </tr>
                            <tr>
                                <th>Charge Amount</th>
                                <td>${{charge_amount}}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>
            </b-col>
        </b-row>        
    </b-container>
</template>
<script>
    import CountrySelect from '../CountrySelect'
    import StateSelect from '../StateSelect'
    import Multiselect from 'vue-multiselect'
    export default {
        components: {CountrySelect, StateSelect, Multiselect},
        data() {
            return {
                order_id: null,
                project: null,

                ordernumber: null,

                billing: {
                    first_name: '',
                    last_name: '',
                    street_1: '',
                    street_2: '',
                    city: '',
                    state: '',
                    postal_code: '',
                    country: 'US',
                    phone: ''
                },

                charge_amount: 0,

                coupon: {
                    coupon_code: null,
                    type: null,
                    amount: 0,
                    percent: 0
                },

                recordDays: [],

                week: [
                    'Sunday',
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday'
                ],

                schedule: {}
            };
        },
        methods: {
            getNextRecordDay (start) {
                let date = new Date()
                let d = start || date.getDay()
                let nextD = (d === 1) ? 1 : d + 1

                if (nextD >= this.week.length) {
                    nextD = 1
                }

                let recordDay = null


                for (var i = nextD; i < this.week.length; i++) {
                    if (i === 0 || i === 6) continue // Sunday or Saturday, skip

                    for (var j = 0; j < this.recordDays.length; j++) {
                        if (this.recordDays[j] === this.week[i]) { // record day is today, look for next cycle
                            recordDay = i
                            break
                        }
                    }

                    if (recordDay) {
                        this.setSchedule(recordDay);
                        break
                    }
                }

                if(!recordDay) {
                    return this.getNextRecordDay(1)
                }
            },
            setSchedule (day) {
                let scriptDay = (day === 1) ? 5 : day - 1
                let deliveryDay = (day === 5) ? 1 : day + 1

                this.schedule[this.week[scriptDay]] = 'file-alt'
                this.schedule[this.week[day]] = 'microphone'
                this.schedule[this.week[deliveryDay]] = 'file-audio'
            }
        },
        computed: {
            coupon_amount () {
                if (!this.coupon.coupon_code) {
                    return null
                }

                if (this.coupon.type == 'amount') {
                    return (this.subtotal - this.coupon.amount).toFixed(2)
                } else {
                    return (this.subtotal * this.coupon.percent).toFixed(2)
                }
            },
            extra_words_fee() {
               var extra_words_fee = 0;
               for(var i = 0; i < this.project.prompts.length; i++) {
                   extra_words_fee += parseFloat(this.project.prompts[i].extra_words_fee);
               }

               return extra_words_fee.toFixed(2);
           },
           subtotal() {
               var subtotal = 0;
               for(var i = 0; i < this.project.prompts.length; i++) {
                   subtotal += parseFloat(this.project.prompts[i].amount);
               }

               return (subtotal + parseFloat(this.project.record_fee)).toFixed(2);
           },
           total_amount() {
               if (this.coupon.code) {
                   return (this.subtotal - this.coupon.amount).toFixed(2)
               }
               return this.subtotal;
           },
           talentName () {
               return (this.project) ? this.project.talent.persona : ''
           },
           weekdays () {
               return this.week.filter((day, i) => { return (i !== 0 && i !== 6) })
           },
           recordSchedule () {
               return (this.recordDays && this.recordDays.length > 0 && this.recordDays[0] != '')
           }
        },
        created() {
            if( typeof( this.$route.params.id ) !== 'undefined' ) {
                 this.order_id = this.$route.params.id;
            }
            
            this.$store.dispatch('order/read', this.order_id)
                .then(order => {
                    this.project = order.projects[0]
                    this.ordernumber = order.id
                    this.charge_amount = order.total_amount
                    
                    if (order.coupon) {
                        this.coupon = order.coupon
                    }

                    this.recordDays = this.project.talent.record_day

                    if (this.recordDays && this.recordDays.length > 0 && this.recordDays[0] != "") {
                        this.getNextRecordDay()
                    }

                    this.billing.first_name = order.user.first_name
                    this.billing.last_name = order.user.last_name

                    this.billing.street_1 = order.street_1
                    this.billing.street_2 = order.street_2
                    this.billing.city = order.city
                    this.billing.state = order.state
                    this.billing.country = order.country
                    this.billing.postal_code = order.postal_code
                    this.billing.phone = order.phone

                    if (this.project.status === 'draft') {
                        // redirect to checkout
                    }
                })

        }
    };
</script>


// WEBPACK FOOTER //
// prompts/components/checkout/Success.vue